(function () {
  'use strict';
  angular.module('vcdms.vcdocument')
    .component('documentconfig', {
      restrict: 'E',
      bindings: {},
      template: `
        <div class="panel panel-info">
        <div class="panel-heading">
          <h3>Patientenbezogene Dokumentkategorien</h3>
        </div>
        <div class="panel-body"></div>
          <div class="modalspacer">
            <label>Häufig gebrauchte Dokumentkategorien</label>
            <listeditor list="vm.dmspatientcat.dmspatientcat" parentsave="vm.childsavepat(list)"></listeditor>
          </div>
        </div>
                <div class="panel panel-info spacer-top">
        <div class="panel-heading">
          <h3>Allgemeine Dokumentkategorien</h3>
        </div>
        <div class="panel-body"></div>
          <div class="modalspacer">
            <label>Häufig gebrauchte Dokumentkategorien</label>
            <listeditor list="vm.dmsgencat.dmsgencat" parentsave="vm.childsavegen(list)"></listeditor>
          </div>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Config', 'Rlog', 'vertxEventBusService',
        function ($log, Config, Rlog, vertxEventBusService) {
          let vm = this;
          vm.childsavepat = childsavepat;
          vm.childsavegen = childsavegen;

          vm.$onInit = function () {
            // db.appconfig.insert({_id: 'dmsgencat', dmsgencat: conf.dmsgencat});
            // db.appconfig.insert({_id: 'dmspatientcat', dmspatientcat: conf.dmspatientcat});
            Config.$find('dmsgencat').$then(function (dmsgencat) {
              vm.dmsgencat = dmsgencat;
              // intialize if still empty
              if (angular.isUndefined(vm.dmsgencat.dmsgencat)) {
                vm.dmsgencat._id = 'dmsgencat';
                vm.dmsgencat.dmsgencat = [];
              }
            });
            Config.$find('dmspatientcat').$then(function (dmspatientcat) {
              vm.dmspatientcat = dmspatientcat;
              // intialize if still empty
              if (angular.isUndefined(vm.dmspatientcat.dmspatientcat)) {
                vm.dmspatientcat._id = 'dmspatientcat';
                vm.dmspatientcat.dmspatientcat = [];
              }
            });
          };


          function childsavegen(list) {
            vm.dmsgencat.dmsgencat = list;
            savegen();
          }

          function childsavepat(list) {
            vm.dmspatientcat.dmspatientcat = list;
            savepat();
          }


          function savegen() {
            if (vm.dmsgencat.$hasPendingActions()) {
              vm.dmsgencat.$cancel();
            }
            vm.dmsgencat.$save();
          }

          function savepat() {
            if (vm.dmspatientcat.$hasPendingActions()) {
              vm.dmspatientcat.$cancel();
            }
            vm.dmspatientcat.$save();
          }


          vertxEventBusService.on('config.update', function (message) {
            // $log.debug('debug: config update received: ', message);
            let messages = message.split(':');
            if (messages[0] === 'dmspatientcat') {
              vm.dmspatientcat.$refresh().$then(function () {
                $log.debug('debug: config refresh dmspatientcat');
              }, function (error) {
                $log.debug('debug: config refresh dmspatientcat failed: ', error);
              });
            }

            if (messages[0] === 'dmsgencat') {
              vm.dmsgencat.$refresh().$then(function () {
                $log.debug('debug: config refresh dmsgencat');
              }, function (error) {
                $log.debug('debug: config refresh dmsgencat failed: ', error);
              });
            }
          });


        }] // controller
    }); // component

// klammerfriedhof
}());
